<template>
  <v-container id="user-list">
    <v-row>
      <v-col>{{ userId ? "Edição " : "Cadastro" }} de usuário</v-col>
      <v-col class="text-right">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          :to="'/inscricao/auth/usuarios'"
        >
          Voltar para Lista de Usuários
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Nome do usuário"
          name="nome"
          type="text"
          required
          v-model="usuario.nome"
        ></v-text-field>
      </v-col>
      <v-col>
        <combo-estados
          :filter="usuario"
          :valor="'nome'"
          :filled="false"
          :multiple="true"
          :tipoInscricao="'A'"
        ></combo-estados>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="E-mail"
          name="asd"
          type="email"
          required
          v-model="usuario.email"
          validate-on-blur
          :error-messages="emailErrors"
          @blur="(v) => verifyEmail(v.target.value)"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="isFullAdmin">
      <v-col>
        <v-text-field
          label="Senha"
          name="sad"
          type="password"
          required
          autocomplete="new-password"
          v-model="usuario.senha"
        ></v-text-field>
      </v-col>
      <v-col lg="3" md="3" cols="12">
        <v-checkbox
          v-model="usuario.trocarSenhaLogin"
          id="trocarSenha"
          color="primary"
          label="Trocar senha no próximo acesso"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="insertUser">
          {{ userId ? "Editar " : "Cadastrar" }} Usuário
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { usuarioAPI } from "@/apis";
import { mapActions, mapGetters } from "vuex";
import { emailValidatorRegex } from "@/helpers/validator";
import ComboEstados from "@/modules/municipios/components/ComboEstados.vue";

export default {
  components: { ComboEstados },
  data() {
    return {
      usuario: { trocarSenhaLogin: !this.userId ? true : false, uf: [] },
      emailRules: [async (v) => this.verifyEmail(v)],
      emailErrors: null,
      userId: this.$route.params.id,
    };
  },
  mounted() {
    if (this.userId) {
      this.setLoading(true);

      usuarioAPI
        .getId(this.userId)
        .then((resp) => {
          delete resp.data.senha;

          this.usuario = resp.data;
          this.usuario.uf = resp.data.ufs ? resp.data.ufs.split(",") : [];
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar usuário");
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async verifyEmail(v) {
      this.emailErrors = null;
      if (!v) {
        this.emailErrors = "Campo Obrigatório";
        return;
      }

      if (emailValidatorRegex.test(v)) {
        this.emailErrors = null;
        return;
      }

      this.emailErrors = "Email inválido";
    },
    insertUser() {
      if (this.emailErrors) return;
      this.setLoading(true);
      const payload = {
        ...this.usuario,
        ufs: this.usuario.uf.map((item) => `${item}`).join(","),
      };
      if (this.userId) {
        usuarioAPI
          .update(payload)
          .then((_) => {
            this.setLoading(false);

            this.$router.push("/inscricao/auth/usuarios");
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao cadastrar usuário");
          });
      } else {
        usuarioAPI
          .create(payload)
          .then((_) => {
            this.setLoading(false);

            this.$router.push("/inscricao/auth/usuarios");
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao cadastrar usuário");
          });
      }
    },
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
};
</script>
